var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { default as seededshuffle } from 'seededshuffle';
import { OrderedOption } from '../OrderedOption/OrderedOption';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { list } from '../../../../utils/serializr/schema/list';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { OrderedTaskStep } from '../OrderedTaskStep/OrderedTaskStep';
import { object } from '../../../../utils/serializr/schema/object';
import { OrderedTaskEdit } from './modules/OrderedTaskEdit';
import { OrderedTaskEvaluate } from './modules/OrderedTaskEval';
import { Actor } from '../../../../classes/actor/Actor';
import { OrderedTaskInfo } from './modules/OrderedTaskInfo';
import { strip } from '../../../../utils/serializr/schema/inner/strip';
import { OrderedTaskSteps } from './modules/OrderedTaskSteps';
import { OrderedTaskOrders } from './modules/OrderedTaskOrders';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { OrderedTaskProgress } from './modules/OrderedTaskProgress';
export class OrderedTask extends Actor {
    type = 'orderedtask';
    steps;
    options;
    correctOrderString = '';
    numberOfTries = 1;
    inactiveEditSteps;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get correctIndexOrder() {
        return this.correctOrders.primaryCorrectIndexOrder;
    }
    set correctIndexOrder(o) { }
    get orderedTaskEdit() {
        return new OrderedTaskEdit(this);
    }
    get orderedTaskInfo() {
        return new OrderedTaskInfo(this);
    }
    get orderedTaskSteps() {
        return new OrderedTaskSteps(this);
    }
    get orderedTaskEvaluate() {
        return new OrderedTaskEvaluate(this);
    }
    get taskProgress() {
        return new OrderedTaskProgress(this);
    }
    get correctOrders() {
        return new OrderedTaskOrders(this);
    }
    get question() {
        return this.parent;
    }
    get shuffledOptions() {
        if (!this.question.shouldShuffle) {
            return this.options;
        }
        return seededshuffle.shuffle(this.options, this.question.shuffleSeed, true);
    }
    get hoveringOption() {
        return this.options.find(option => option.isHovering);
    }
    get step() {
        return this.steps.find(step => !step.stepProgress.isStepCompleted) || this.steps[this.steps.length - 1];
    }
    get latestCompletedStep() {
        return [...this.steps].reverse().find(step => step.stepProgress.isStepCompleted);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                options: withDefault(list(object(OrderedOption)), [{}, {}, {}]),
                correctOrderString: withDefault(primitive, ''),
                correctIndexOrder: withDefault(list(primitive), [0]),
                steps: withDefault(list(object(OrderedTaskStep)), []),
                inactiveEditSteps: withDefault(list(object(OrderedTaskStep)), []),
                numberOfTries: true,
            },
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {
                options: strip((task) => task.options.map(option => option.stripped)),
                steps: strip((task) => task.steps.map(step => step.stripped)),
                correctIndexOrder: strip((task) => task.correctIndexOrder),
                numberOfTries: true,
            },
        };
    }
}
__decorate([
    editable('shallow')
], OrderedTask.prototype, "steps", void 0);
__decorate([
    editable('shallow')
], OrderedTask.prototype, "options", void 0);
__decorate([
    editable()
], OrderedTask.prototype, "correctOrderString", void 0);
__decorate([
    editable()
], OrderedTask.prototype, "numberOfTries", void 0);
__decorate([
    editable('shallow')
], OrderedTask.prototype, "inactiveEditSteps", void 0);
__decorate([
    memoize
], OrderedTask.prototype, "orderedTaskEdit", null);
__decorate([
    memoize
], OrderedTask.prototype, "orderedTaskInfo", null);
__decorate([
    memoize
], OrderedTask.prototype, "orderedTaskSteps", null);
__decorate([
    memoize
], OrderedTask.prototype, "orderedTaskEvaluate", null);
__decorate([
    memoize
], OrderedTask.prototype, "taskProgress", null);
__decorate([
    memoize
], OrderedTask.prototype, "correctOrders", null);
__decorate([
    computed
], OrderedTask.prototype, "shuffledOptions", null);
__decorate([
    memoize
], OrderedTask, "serializeInfo", null);
__decorate([
    memoize
], OrderedTask, "stripInfo", null);
